import { render, staticRenderFns } from "./prizeDraw.vue?vue&type=template&id=1220a8d8&scoped=true&"
import script from "./prizeDraw.vue?vue&type=script&lang=ts&"
export * from "./prizeDraw.vue?vue&type=script&lang=ts&"
import style0 from "./prizeDraw.vue?vue&type=style&index=0&id=1220a8d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1220a8d8",
  null
  
)

export default component.exports